import { ValidatorFn } from '@angular/forms';
import { InputControlType } from './../../enum';
import { BaseInput, BaseInputConstructor } from './base-input';

interface ColorPickerInputConstructorInterface extends BaseInputConstructor {
    type?: string;
}

export class ColorPickerInput extends BaseInput {
    /**
     * Specifies the type of input as 'textbox'.
     */
    override inputType = 'color-picker';
    /**
     * The type of the input control.
     */
    type: InputControlType = 'color-picker';

    /**
     * Creates a new instance of TextInput.
     *
     * @param options - The options for configuring the text input.
     *
     * @property {InputControlType} options.type - The type of the input control.
     */
    constructor(options: ColorPickerInputConstructorInterface) {
        super(options);

        const validators: ValidatorFn[] = [];
        if (this.validator) {
            validators.push(this.validator);
        }

        this.setValidators(validators);
    }

    clone(): ColorPickerInput {
        return new ColorPickerInput(this.__internalConstructor__);
    }
}
